import React, { useState, useEffect }from 'react';
import Slider from "react-slick";
import axios from 'axios';

// Components //
import TitleSection from "../../molecules/title-section";
import BookCard from '../../molecules/book-card/bookCard';
import ShareModal from "../../molecules/share-modal/shareModal";
import Loading from "../../atoms/loading/loading";
import Label from '../../atoms/label/label';

// References //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Services //
import { getAccessToken } from "../../../services/accessToken";

// Styles //
import "./booksSection.scss";

const BooksSeccion = (props: ReferenciaContenido) => {
    const {
        tituloGeneral,
        listaLibros,
    } = props;

    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState<number>(0);
    const [listBooksId, setListBooksId] = useState<any[]>([]);
    const [listBooks, setListBooks] = useState<any[]>([]);
    const [visibility, setVisibility] = useState<boolean>(false);
    const [currentUrl, setCurrentUrl] = useState("");
    const [loading, setLoading] = useState<boolean>(false);

    const popupCloseHandler = (e) => {
        setVisibility(e);
    };

    const onSetCurrentUrl = (url: string) => {
        setCurrentUrl(url)
    }

    useEffect(() => {
        const getBooksDetail = async () => {
            const token = await (await getAccessToken()).data.data.accessToken;
            setLoading(true);
            try {
                const endpoints = listBooksId.map((id) => `${process.env.URL_API_BIBLIOTECA}/search/api/v1/filterByBookId?mmsId=${id}`);
                const requests = endpoints.map(endpoint => axios.get(endpoint, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }));
                const response = await axios.all(requests);
                const successfulResponses = response.filter(res => res.data.status === 200);
                setListBooks(successfulResponses);
            } catch (error) {
                console.error(error, "error");
            }
            setLoading(false);
        }

        getBooksDetail();
    }, [listBooksId])

    useEffect(() => {
        if (listaLibros) setListBooksId([...listaLibros]);
    }, []);

    const CarouselGeneral = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        arrows: false,
        slidesToScroll: 4,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    variableWidth: true,
                    initialSlide: 1,
                },
            },
        ],
    };

    const goToNext = () => {
        if (sliderIndex < slider.props.children.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => sliderIndex < slider?.props.children.length - 1;

    const renderTypeBook = (obj) => {
        if(obj.tipoContenido == "podcast") 
            return (<Label text="Podcast" icon="icon-podcast"/>)
        if(obj.tipoContenido == "audiobook") 
            return (<Label text="Audiolibro" icon="icon-audiolibro"/>)
        if(obj.tipoContenido == "book" && obj.origenContenido == "digital") 
            return (<Label text="Digital" icon="icon-digital"/>)
        if(obj.tipoContenido == "book" && obj.origenContenido == "physical") 
            return (<Label text="Físico" icon="icon-fisico"/>)
        if(obj.tipoContenido == "film" && obj.origenContenido == "physical") 
            return (<Label text="Físico" icon="icon-fisico"/>)
    }

    return (
        <>
            {(listBooks && listBooks.length > 0) ? (
                <div className="o-books-section">
                    <div className="container">
                        <div className="o-books-section__container">
                            <TitleSection title={tituloGeneral}/>
                            <div className="o-books-section__slider">
                                <div className="arrows-slider">
                                    <span
                                        className={`arrow icon-chevron-left ${isActiveBack() ? "active" : ""
                                            } gtmSliderArrowLeftBook`}
                                        onClick={goToBack}
                                    ></span>
                                    <span
                                        className={`arrow  icon-chevron-right  ${isActiveNext() ? "active" : ""
                                            } gtmSliderArrowRightBook`}
                                        onClick={goToNext}
                                    ></span>
                                </div>
                                {(() => {
                                    if (loading) {
                                        return <Loading />;
                                    } else if (listBooks && listBooks.length > 0) {
                                        return <Slider
                                            ref={(c) => {
                                                setSlider(c);
                                            }}
                                            {...CarouselGeneral}
                                        >
                                            {listBooks.map(({ data }) => (
                                                <BookCard
                                                    key={data}
                                                    title={data.data.titulo}
                                                    author={data.data.autor}
                                                    img={data.data.image && data.data.image.file.url}
                                                    link={`https://www.comfama.com/bibliotecas/libros/detalle/?book=${data.data.mmsId}`}
                                                    onClickShare={popupCloseHandler}
                                                    setLinkUrl={onSetCurrentUrl}>
                                                        {renderTypeBook(data.data)}
                                                </BookCard>
                                            ))}
                                        </Slider>
                                    }
                                })()}
                            </div>    
                        </div>
                    </div>
                    <ShareModal isOpen={visibility} onClose={popupCloseHandler} link={currentUrl} />
                </div>
            ) : null}
        </>
    )
}

export default BooksSeccion;